(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mench-fullscreen-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  function syncBanners(){
    document.querySelectorAll('.mench-fullscreen video').forEach(function(video){
      if(video.getBoundingClientRect().width===0){video.pause();return;}
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.pause();return;}
      video.muted=true;
      var result=video.play();
      if(result&&result.catch){result.catch(function(){});}
    });
  }
  syncBanners();
  window.addEventListener('resize',syncBanners);
  document.addEventListener('shopify:section:load',syncBanners);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mench-hydro-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const source = document.querySelector('.product-single:has(.mt-heading) button[name="add"]');
    if (!source) return;
    document.querySelectorAll('[data-mench-buy]').forEach(link => {
      if (link.dataset.menchBound) return;
      link.dataset.menchBound = 'true';
      link.addEventListener('click', event => {
        if (source.disabled) { event.preventDefault(); return; }
        event.preventDefault();
        source.click();
      });
    });
    const sticky = document.querySelector('[data-mench-sticky]');
    if (sticky && !sticky.dataset.menchBound) {
      sticky.dataset.menchBound = 'true';
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, { threshold: 0.1 });
      observer.observe(source);
      const availability = new MutationObserver(() => {
        document.querySelectorAll('[data-mench-buy]').forEach(link => link.setAttribute('aria-disabled', String(source.disabled)));
      });
      availability.observe(source, { attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('shopify:section:unload', () => { observer.disconnect(); availability.disconnect(); }, { once: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mench-tropical-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const source = document.querySelector('.product-single:has(.mt-heading) button[name="add"]');
    if (!source) return;
    document.querySelectorAll('[data-mench-buy]').forEach(link => {
      if (link.dataset.menchBound) return;
      link.dataset.menchBound = 'true';
      link.addEventListener('click', event => {
        if (source.disabled) { event.preventDefault(); return; }
        event.preventDefault();
        source.click();
      });
    });
    const sticky = document.querySelector('[data-mench-sticky]');
    if (sticky && !sticky.dataset.menchBound) {
      sticky.dataset.menchBound = 'true';
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, { threshold: 0.1 });
      observer.observe(source);
      const availability = new MutationObserver(() => {
        document.querySelectorAll('[data-mench-buy]').forEach(link => link.setAttribute('aria-disabled', String(source.disabled)));
      });
      availability.observe(source, { attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('shopify:section:unload', () => { observer.disconnect(); availability.disconnect(); }, { once: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mench-zero-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const source = document.querySelector('.product-single:has(.mt-heading) button[name="add"]');
    if (!source) return;
    document.querySelectorAll('[data-mench-buy]').forEach(link => {
      if (link.dataset.menchBound) return;
      link.dataset.menchBound = 'true';
      link.addEventListener('click', event => {
        if (source.disabled) { event.preventDefault(); return; }
        event.preventDefault();
        source.click();
      });
    });
    const sticky = document.querySelector('[data-mench-sticky]');
    if (sticky && !sticky.dataset.menchBound) {
      sticky.dataset.menchBound = 'true';
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, { threshold: 0.1 });
      observer.observe(source);
      const availability = new MutationObserver(() => {
        document.querySelectorAll('[data-mench-buy]').forEach(link => link.setAttribute('aria-disabled', String(source.disabled)));
      });
      availability.observe(source, { attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('shopify:section:unload', () => { observer.disconnect(); availability.disconnect(); }, { once: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
